import { memo, useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
const ChipsCell = memo(
  ({
    resetKey,
    className,
    value,
    handleClick,
    color,
    chips,
    selectedChips,
    isRemoveCellActive,
    handleRemoveCell,
    lastUndoAction,
    setResetKey,
    total,
    balance,
  }) => {
    const [placedChips, setPlacedChips] = useState([]);

    useEffect(() => {
      if (resetKey) setPlacedChips([]);
    }, [resetKey]);
    const handlePlaceChip = () => {
      setResetKey(false);
      if (!selectedChips) return;
      setPlacedChips((prevChips) => {
        const totalChipCount = prevChips.reduce(
          (sum, chip) => sum + chip.count,
          0
        );
        if (totalChipCount >= 10) {
          return prevChips;
        }
        const existingChip = prevChips.find(
          (chip) => chip.value === selectedChips.value
        );
        const newTotal = total + selectedChips?.value;
        if (newTotal > balance) {
          return prevChips;
        }
        if (existingChip) {
          return prevChips.map((chip) =>
            chip.value === selectedChips.value
              ? { ...chip, count: chip.count + 1 }
              : chip
          );
        }
        return [...prevChips, { ...selectedChips, count: 1 }];
      });
    };
    const handleUndoChip = (chipValue) => {
      setPlacedChips((prevChips) => {
        return prevChips
          .map((chip) =>
            chip.value === chipValue ? { ...chip, count: chip.count - 1 } : chip
          )
          .filter((chip) => chip.count > 0);
      });
    };

    useEffect(() => {
      if (lastUndoAction?.value === value) {
        handleUndoChip(lastUndoAction?.chipValue);
      }
    }, [lastUndoAction, value]);

    return (
      <div
        role="button"
        style={{
          backgroundColor: `${color}`,
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleClick();
          handlePlaceChip();
        }}
        className={`${className} ${
          value < 0
            ? "border border-[#434343] text-[13px]"
            : " sm:text-base xsm:text-xs text-[14px]"
        }  text-white font-semibold sm:rounded-lg rounded-[6px] flex items-center justify-center relative`}
      >
        {value < 0 ? "2:1" : value}
        {placedChips.map((chip, chipIndex) =>
          Array.from({ length: chip.count }).map((_, index) => {
            const totalPrevChips = placedChips
              .slice(0, chipIndex)
              .reduce((sum, c) => sum + c.count, 0);
            const translateY = (totalPrevChips + index) * 9;

            return (
              <img
                key={`${chip.value}-${index}`}
                style={{ transform: `translateY(-${translateY}px)` }}
                src={chip.url}
                className="md:h-fit sm:h-8 xsm:h-7 h-8 md:w-fit sm:w-8 xsm:w-7 w-8 absolute sm:left-1 xsm:left-0.5 left-1"
                alt=""
              />
            );
          })
        )}
        {chips.some((chip) => chip.count > 0) && isRemoveCellActive && (
          <div
            role="button"
            aria-label="Clear Cell"
            onClick={(e) => {
              e.stopPropagation();
              setPlacedChips([]);
              handleRemoveCell(value);
            }}
            className="absolute -top-1 -right-1 md:h-5 h-4 md:w-5 w-4 rounded-[5px] text-[#b8b8b8] border border-[#b8b8b8] text-[13px] flex items-center justify-center bg-[#1d1d1d] z-20"
          >
            <IoMdClose />
          </div>
        )}
      </div>
    );
  }
);

export default ChipsCell;
